import React from "react";
import DataTable from "../DataTable/DataTable";
import RoomTypePriceTimeline from "./RoomTypePriceTimeline";
import numeral from "numeral";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import DateHelper from "../DateHelper/DateHelper";
import { getWeekOfMonth, startOfMonth } from "date-fns";

export default class RoomTypeDateAnalytics extends React.Component {
  constructor(props) {
    super(props);
    this.datatableRef = React.createRef();
    this.popoverRef = React.createRef();
    this.state = { ...this.props, loading: false, dailyRateOverrides: [] };
    this.onLoadDailyOverridesDataTableSuccess =
      this.onLoadDailyOverridesDataTableSuccess.bind(this);
  }

  componentDidMount() {
    var self = this;
    const { props } = this;

    $(window).on("refresh_data_table", function () {
      self.refresh(props);
    });
  }

  componentDidUpdate(_prevProps, _prevState) {
    var $a = $(this.datatableRef.current).find("a.btn-primary");
    if (this.state.dailyRateOverrides.length === this.state.rates.length) {
      $a.hide();
    } else {
      $a.show()
        .off("click")
        .on("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          var offset = $a.offset();

          $(this.popoverRef.current)
            .show()
            .css({
              top: offset.top,
              left: offset.left + $a.outerWidth() + 10,
            });
        });

      $(document.body).on("click.popover scroll.popover", (e) => {
        $(this.popoverRef.current).hide();
      });
    }
  }

  render() {
    var date = DateHelper.parseDateFromBackend(this.state.date);
    var comparable_date = DateHelper.parseDateFromBackend(
      this.props.comparable_date
    );
    return (
      <>
        <RoomTypePriceTimeline {...this.state} />
        <div className="RoomTypeDateAnalytics">
          <h5>
            {I18n.t("occupancy")}{" "}
            <span
              className="ss-help help"
              title={I18n.t("rates_calendar_analytics_data_helper_text")}
            ></span>
          </h5>
          <div className="row">
            <div className="col-sm-4 container">
              <h3>
                {this.state.current_occupancy.toFixed(2)}
                <sup style={{ left: 2 }}>%</sup>
              </h3>
              <label>
                <span>{I18n.t("current_year")}</span>
              </label>
            </div>
            <div className="col-sm-4 container">
              <h3>
                {this.state.last_year_occupancy_by_week.toFixed(2)}
                <sup style={{ left: 2 }}>%</sup>
              </h3>
              <label>
                <span>
                  {I18n.t("last_year_on", {
                    date:
                      this.weekOfMonth(date) +
                      DateHelper.printDateToScreen(date, " cccc") +
                      " of " +
                      DateHelper.printDateToScreen(date, "MMMM"),
                  })}{" "}
                  &ndash;{" "}
                  {DateHelper.printDateToScreen(comparable_date, "MM/DD/YYYY")}
                </span>
              </label>
            </div>
            <div className="col-sm-4 container">
              <h3>
                {this.state.this_year_compared_to_last_year.toFixed(2)}
                <sup style={{ left: 2 }}>%</sup>
              </h3>
              <label>
                <span>{I18n.t("this_year_compared_to_last_year")}</span>
              </label>
            </div>
          </div>

          <hr />
          <h5>{I18n.t("daily_overrides")}</h5>

          <div ref={this.datatableRef}>
            <DataTable
              endpoint={this.props.daily_overrides_endpoint}
              no_data_text={I18n.t("none")}
              currency_unit={I18n.t("number.currency.format.unit")}
              delimiter={I18n.t("number.currency.format.delimiter")}
              separator={I18n.t("number.currency.format.separator")}
              date_format={this.props.date_format}
              time_format={this.props.time_format}
              read_only={this.props.read_only}
              onLoadDataSuccess={this.onLoadDailyOverridesDataTableSuccess}
            />
          </div>
          <div
            className="popover"
            ref={this.popoverRef}
            style={{ display: "none", position: "fixed" }}
          >
            <div className="popover-body">{this.renderPopoverContent()}</div>
          </div>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </>
    );
  }

  onLoadDailyOverridesDataTableSuccess(response) {
    const { data = [] } = response;
    this.setState({ dailyRateOverrides: data });
  }

  renderPopoverContent() {
    const rate_buttons = this.state.rates
      .filter(
        (rate) =>
          !this.state.dailyRateOverrides.find((e) => e.rate_id === rate.id)
      )
      .map((rate) => {
        return (
          <li key={rate.id}>
            <a
              href={this.state.new_daily_rate_paths[rate.id]}
              data-id={rate.id}
              className="modal-iframe"
            >
              {rate.code} ({rate.name})
            </a>
          </li>
        );
      });
    return <div className="content">{rate_buttons}</div>;
  }

  refresh() {
    var self = this;
    this.setState({ loading: true });
    $.ajax({
      type: "POST",
      url: self.state.refresh_endpoint,
      data: {},
    }).done(function (data) {
      if (data) {
        var state = Object.assign({}, self.state);
        state = data;
        state.loading = false;
        self.setState(state);
      }
    });
  }

  /**
   * Helper functions
   */

  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  weekOfMonth(m) {
    var w = getWeekOfMonth(m) - getWeekOfMonth(startOfMonth(new Date(m)));

    if (w == 2) {
      return I18n.t("second");
    } else if (w == 3) {
      return I18n.t("third");
    } else if (w == 4) {
      return I18n.t("fourth");
    } else if (w == 5) {
      return I18n.t("fifth");
    } else {
      return I18n.t("first");
    }
  }
}
